import _asyncToGenerator from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/regenerator";
import checkContainMedia from '@anm/helpers/checkContainMedia';
import useVideoStatusChecker from '@anm/hooks/useVideoStatusChecker';
import isVideoBlocked from '../../helpers/isVideoBlocked';
import isEqual from 'lodash/fp/isEqual';
import { useEffect, useRef, useState } from 'react';
import playerConfig from '../../config';
import getManifest from '../../helpers/getManifest';
import parseManifest from '../../helpers/parseManifest';
import { VideoStatusCode } from '../../types';
import isSupportedCodec from '@anm/helpers/is/isSupportedCodec';
import isStreamVideo from '@anm/helpers/is/isStreamVideo';
import getBlockedVideoData from '../../helpers/getBlockedVideoData';

var _playerConfig = playerConfig(),
    supportedExtensions = _playerConfig.supportedExtensions;

export var useVideoData = function useVideoData(_ref) {
  var env = _ref.env,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'api' : _ref$source,
      hostId = _ref.hostId,
      manifest = _ref.manifest,
      playerWidth = _ref.playerWidth,
      parentVideoData = _ref.parentVideoData;

  var _useState = useState(),
      color = _useState[0],
      setColor = _useState[1];

  var _useState2 = useState(),
      errorCode = _useState2[0],
      setErrorCode = _useState2[1];

  var _useState3 = useState(),
      errorMessage = _useState3[0],
      setErrorMessage = _useState3[1];

  var _useState4 = useState(),
      videoData = _useState4[0],
      setVideoData = _useState4[1];

  useEffect(function () {
    if (parentVideoData || !hostId) return;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _videos$, _response$password, _response$password2, response, containSupportedVideo, videos, isNoVideo, isProcessingError, isBlocked, isCodecError, isNoVideoError, isVideoInProcess, isProtected, _ref3, code, message, meta;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.t0 = manifest;

              if (_context.t0) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return getManifest({
                hostId: hostId,
                source: source,
                env: env
              });

            case 5:
              _context.t0 = _context.sent;

            case 6:
              response = _context.t0;
              containSupportedVideo = checkContainMedia({
                supportedExtensions: supportedExtensions,
                list: response.main,
                type: 'video'
              });
              videos = response.main.filter(function (s) {
                return s.type === 'video';
              });
              isNoVideo = !videos.length;
              isProcessingError = !!response.error;
              isBlocked = isVideoBlocked(response);

              if (!isBlocked) {
                _context.next = 16;
                break;
              }

              setErrorCode(VideoStatusCode.blocked);
              setVideoData(getBlockedVideoData(response));
              return _context.abrupt("return");

            case 16:
              isCodecError = videos.length === 1 && !isStreamVideo((_videos$ = videos[0]) === null || _videos$ === void 0 ? void 0 : _videos$.path) && !isSupportedCodec(videos[0]);
              isNoVideoError = isNoVideo && !isProcessingError && !isBlocked;
              isVideoInProcess = !containSupportedVideo && !isNoVideo && !isProcessingError && !isBlocked;
              isProtected = !!((_response$password = response.password) !== null && _response$password !== void 0 && _response$password.hash) && !!((_response$password2 = response.password) !== null && _response$password2 !== void 0 && _response$password2.isEnabled);
              _context.t1 = true;
              _context.next = _context.t1 === isProtected ? 23 : _context.t1 === isProcessingError ? 25 : _context.t1 === isCodecError ? 28 : _context.t1 === isNoVideoError ? 30 : _context.t1 === isVideoInProcess ? 32 : 33;
              break;

            case 23:
              setErrorCode(VideoStatusCode["protected"]);
              return _context.abrupt("break", 33);

            case 25:
              setErrorCode(VideoStatusCode.processingError);
              setErrorMessage(response.error || '');
              return _context.abrupt("break", 33);

            case 28:
              setErrorCode(VideoStatusCode.codecErorr);
              return _context.abrupt("break", 33);

            case 30:
              setErrorCode(VideoStatusCode.no_video);
              return _context.abrupt("break", 33);

            case 32:
              setErrorCode(VideoStatusCode.in_process);

            case 33:
              setVideoData(parseManifest(response, playerWidth));
              _context.next = 42;
              break;

            case 36:
              _context.prev = 36;
              _context.t2 = _context["catch"](0);
              _ref3 = _context.t2, code = _ref3.code, message = _ref3.message, meta = _ref3.meta;
              setErrorCode(code);
              setErrorMessage(message);
              (meta === null || meta === void 0 ? void 0 : meta.color) && setColor(meta.color);

            case 42:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 36]]);
    }))();
  }, [hostId, playerWidth, parentVideoData]);
  return parentVideoData || {
    videoData: videoData,
    errorCode: errorCode,
    errorMessage: errorMessage,
    color: color
  };
};
export var usePlayerData = function usePlayerData(_ref4) {
  var env = _ref4.env,
      hostId = _ref4.hostId,
      manifest = _ref4.manifest,
      playerWidth = _ref4.playerWidth,
      parentVideoData = _ref4.parentVideoData;

  var _useState5 = useState(),
      password = _useState5[0],
      setPassword = _useState5[1];

  var _useState6 = useState(false),
      isPending = _useState6[0],
      setIsPending = _useState6[1];

  var _useState7 = useState(),
      videoInfo = _useState7[0],
      setVideoInfo = _useState7[1];

  var initialVideoInfo = useVideoData({
    env: env,
    hostId: hostId,
    manifest: manifest,
    playerWidth: playerWidth,
    parentVideoData: parentVideoData,
    source: 'cdn'
  });
  var isManifestInProcess = !parentVideoData && initialVideoInfo.errorCode === VideoStatusCode.in_process;

  var _useVideoStatusChecke = useVideoStatusChecker({
    hostId: hostId,
    supportedExtensions: supportedExtensions,
    progress: isManifestInProcess ? 100 : null
  }),
      isVideoReady = _useVideoStatusChecke.isMediaReady,
      videoManifest = _useVideoStatusChecke.videoManifest;

  useEffect(function () {
    if (!initialVideoInfo || isEqual(initialVideoInfo, videoInfo)) {
      return;
    }

    setVideoInfo(initialVideoInfo);
  }, [initialVideoInfo.videoData, initialVideoInfo.errorCode, initialVideoInfo.errorMessage]);
  useEffect(function () {
    if (!isVideoReady || !videoManifest) return;
    setVideoInfo({
      videoData: parseManifest(videoManifest)
    });
  }, [isVideoReady, videoManifest]);
  useEffect(function () {
    if (typeof password === 'undefined') {
      return;
    }

    setIsPending(true);
    getManifest({
      env: env,
      hostId: hostId,
      query: password,
      source: 'cdn'
    }).then(function (response) {
      return setVideoInfo({
        videoData: parseManifest(response, playerWidth)
      });
    })["catch"](function (err) {
      var _ref5 = err,
          code = _ref5.code;
      setVideoInfo({
        errorCode: code
      });
    })["finally"](function () {
      return setIsPending(false);
    });
  }, [password, playerWidth]);
  return [videoInfo, isPending, setPassword];
};
export var usePlayerWidth = function usePlayerWidth(playerWithFromProps) {
  var playerRef = useRef(null);

  var _useState8 = useState(playerWithFromProps),
      playerWidth = _useState8[0],
      setPlayerWidth = _useState8[1];

  useEffect(function () {
    if (!playerRef.current || playerWidth) return;
    setPlayerWidth(playerRef.current.offsetWidth || 1);
  }, [playerRef.current]);
  return [playerRef, playerWidth];
};